var locationMaps = [].slice.call(document.querySelectorAll('.map-container')),
	apiKey = 'AIzaSyB3PMdQmP1pcofIj6BXKm_mnMCa_4nLT5s';

	if(locationMaps.length) {
		window.initMap = function() {
			locationMaps.forEach(function(mapElement) {
				initMap(mapElement);
			});
		};
	
		scriptWaypoint(locationMaps[0], 'https://maps.googleapis.com/maps/api/js?key='+apiKey+'&callback=initMap', '150%');
	}
	

	function initMap(mapElement) {
		var openWindow,
			currentMarker,
			pin = '/assets/images/icons/map-pin.svg',
			currentPin = '/assets/images/icons/map-pin-current.svg';
	
		axios.get('/map-section/'+mapElement.getAttribute('data-location')).then(function(r) {
			var locations = r.data.locations,
				center = JSON.parse('['+r.data.center+']'),
				mapOptions = {
					zoom: r.data.zoom,
					streetViewControl: false, // hide the yellow Street View pegman
					scaleControl: true, // allow users to zoom the Google Map
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					scrollwheel: false,
					center: new google.maps.LatLng(center[0], center[1]),
					styles: mapStyles
				};
	
			map = new google.maps.Map(mapElement, mapOptions);
	
			locations.forEach(function(location) {
				var isLocationPage = location.openWindow,
					coordinates = JSON.parse('['+location.coordinates+']'),
					latLng = new google.maps.LatLng(coordinates[0], coordinates[1]),
					infowindow = new google.maps.InfoWindow({
						position: latLng,
						content: location.html
					}),
					marker = new google.maps.Marker({
						map: map,
						position: latLng,
						draggable: false,
						animation: google.maps.Animation.DROP,
						icon: pin
					});
	
				if(!openWindow) {
					infowindow.open(map, marker); // Remove this to close infowindow by default
					openWindow = infowindow;
	
					marker.setIcon(currentPin);
					  currentMarker = marker;
				}
	
				infowindow.addListener('closeclick', function() {
					openWindow = false;
					currentMarker.setIcon(pin);
				});
	
				marker.addListener('click', function() {
					if(currentMarker)
						currentMarker.setIcon(pin);
	
					if(openWindow)
						openWindow.close();
	
					  if(currentMarker != marker) {
						  marker.setIcon(currentPin);
						  currentMarker = marker;
	
						  infowindow.open(map, marker);
						  openWindow = infowindow;
					  }
					  else {
						  openWindow = false;
						  currentMarker = false;
					  }
				});
			});
		});
	}